var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "../../themes/styled";
import Box from "../../box/Box";
var themeFieldColor = function (p) {
    return p.currentState && p.theme
        ? p.theme.component.formfield[p.currentState].borderColor
        : "gray";
};
var StyledBorder = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    position: relative;\n    /* overflow: hidden; */\n    border-width: 2px;\n    border-radius: 4px;\n    border-style: solid;\n    border-color: ", ";\n\n    ", ";\n"], ["\n    box-sizing: border-box;\n    position: relative;\n    /* overflow: hidden; */\n    border-width: 2px;\n    border-radius: 4px;\n    border-style: solid;\n    border-color: ", ";\n\n    ", ";\n"])), themeFieldColor, function (p) {
    if (p.disabled || p.readOnly) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                background-color: ", ";\n                pointer-events: none;\n            "], ["\n                background-color: ", ";\n                pointer-events: none;\n            "])), themeFieldColor);
    }
    else {
        return "";
    }
});
function FieldBorder(_a) {
    var fieldState = _a.fieldState, children = _a.children, rest = __rest(_a, ["fieldState", "children"]);
    return (React.createElement(StyledBorder, __assign({}, fieldState, rest), children));
}
export default FieldBorder;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FieldBorder.js.map